/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable consistent-return */
import { Box, Flex, Text, ListItem, UnorderedList } from '@chakra-ui/react';
import { useSelector, useDispatch } from 'react-redux';
import { useRef, useState, useEffect, useMemo, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { CheckCircleIcon, InfoOutlineIcon } from '@chakra-ui/icons';

import {
  FetchBlockOutputs,
  getBaseScenario,
  getFormulaList,
  getPlannerBlock,
  getSelectedIndicators,
  UpdateIndicatorFormula,
} from 'redux/PlannerModeSlice';
import FunctionIconComponent from 'components/Icons/FunctionIcon';

const NewToolbarFormula = () => {
  const { blockId } = useParams();
  const inputReference: any = useRef(null);
  const formulaReference: any = useRef(null);
  const dispatch: any = useDispatch();

  const baseScenario = useSelector(getBaseScenario);
  const plannerBlock = useSelector(getPlannerBlock);
  const formulaList = useSelector(getFormulaList);
  const selectedIndicators = useSelector(getSelectedIndicators);

  const [filterValue, setfilterValue]: any = useState(null);
  const [formulaUI, setFormulaUI]: any = useState();
  const [formula, setFormula] = useState(selectedIndicators?.formula);
  const [message, setMessage]: any = useState({ type: '', text: '', errorStatus: false });
  const [hover, setHover] = useState(false);
  const [isOptionsVisible, setIsOptionsVisible] = useState(false);

  // useEffect(() => {
  //   if (formula) {
  //     let localFormula: string = formula;
  //     localFormula = localFormula.replace(/'/g, '');
  //     localFormula = localFormula.replace(/\./g, ' ');
  //     Object.keys(selectedIndicators?.calculated_formula?.formula_map).forEach((key: any) => {
  //       const regex = new RegExp(selectedIndicators?.calculated_formula?.formula_map[key], 'g');
  //       if (key.includes('ind')) {
  //         localFormula = localFormula.replace(
  //           regex,
  //           `<p class="formula-bar-indicator" style="margin: 0 .5rem 0 .5rem;">${selectedIndicators?.calculated_formula?.formula_map[key]}</p>`,
  //         );
  //       } else if (key.includes('dim')) {
  //         localFormula = localFormula.replace(
  //           regex,
  //           `<p class="formula-bar-dimension" style="margin: 0 .5rem 0 .5rem;">${selectedIndicators?.calculated_formula?.formula_map[key]}</p>`,
  //         );
  //       } else if (key.includes('block')) {
  //         localFormula = localFormula.replace(
  //           regex,
  //           `<p class="formula-bar-block" style="margin: 0 .5rem 0 .5rem;">${selectedIndicators?.calculated_formula?.formula_map[key]}</p>`,
  //         );
  //       } else if (key.includes('item')) {
  //         localFormula = localFormula.replace(
  //           regex,
  //           `<p class="formula-bar-item" style="margin: 0 .5rem 0 .5rem;">${selectedIndicators?.calculated_formula?.formula_map[key]}</p>`,
  //         );
  //       } else if (key.includes('prop')) {
  //         localFormula = localFormula.replace(
  //           regex,
  //           `<p class="formula-bar-property" style="margin: 0 .5rem 0 .5rem;">${selectedIndicators?.calculated_formula?.formula_map[key]}</p>`,
  //         );
  //       }
  //     });
  //     setFormulaUI(`
  //   <div class="formula">
  //   ${localFormula}
  //  </div>
  //   `);
  //   }
  // }, []);

  useEffect(() => {
    setFormula(selectedIndicators?.formula);
  }, [selectedIndicators]);

  useEffect(() => {
    const shouldVisible = Boolean(filterValue);
    setIsOptionsVisible(shouldVisible);
  }, [filterValue, formula]);

  const fetchIndicatorsData = () => {
    const idArray = plannerBlock?.dimensions
      .filter((item: any) => item.name !== 'Time')
      .map((item: any) => item.id);
    const dimensionIds = idArray.join(', ');
    const payload = {
      blockId,
      params: {
        dim_id: dimensionIds,
        indicator_filter: 'all',
        scenario_id: baseScenario?.id,
      },
    };
    dispatch(FetchBlockOutputs(payload));
  };

  const handleFormulaBlur = () => {
    if (message.type === 'success') {
      setMessage({ type: '', text: '', errorStatus: false });
    } else if (message.type === 'error') {
      setMessage({ type: 'error', text: message.text, errorStatus: false });
    }
  };

  const selectOption = useCallback(
    (optionUI: string, option: string, type?: string) => {
      if (inputReference?.current) {
        inputReference?.current?.focus();
      }
      if (formulaReference?.current) {
        formulaReference?.current?.focus();
      }
      const formulaArrayUI = formulaUI.split(/(<p[^>]*>[^<]*<\/p>)(?![^']*'[^']*')/g);
      const formulaArray = formula.split(' ');
      formulaArray.splice(-1, 1, option);
      formulaArrayUI.splice(-1, 1, optionUI);
      const formulaString = formulaArray
        .map((element: any) => {
          if (element === option) {
            return option;
          }
          return element;
        })
        .join(' ');
      const formulaStringUI = formulaArrayUI
        .map((element: any) => {
          if (element === optionUI) {
            return optionUI;
          }
          return element;
        })
        .join(' ');
      setFormula(formulaString);
      setFormulaUI(formulaStringUI);
      setfilterValue('');
    },
    [formula],
  );

  const getIndicatorsInCurrentBlock = useMemo(() => {
    const currentBlocksIndicator = formulaList?.blocks?.filter(
      (item: any) => item?.id === Number(blockId),
    );
    return currentBlocksIndicator[0]?.indicators?.reduce((accumulator: any, option: any) => {
      if (option?.name?.toLowerCase()?.includes(filterValue?.toLowerCase())) {
        return [
          ...accumulator,
          <UnorderedList
            key={option?.id}
            onClick={() =>
              selectOption(
                `<p class="formula-indicator" style={{margin:'0 .5rem 0 .5rem'}}>${option?.name}</p>`,
                `${option?.name}`,
                'IndicatorsInCurrentBlock',
              )
            }
            display={'flex'}
            justifyContent={'space-between'}
            my={2}
          >
            <ListItem>
              <Text className='formula-indicator'>{option?.name}</Text>
            </ListItem>
            <Text>{option?.help || ''}</Text>
          </UnorderedList>,
        ];
      }
      return accumulator;
    }, []);
  }, [filterValue]);

  const getIndicatorsInOthersBlock = useMemo(() => {
    const othersBlocksIndicator = formulaList?.blocks?.filter(
      (item: any) => item?.id !== Number(blockId),
    );
    const otherBlockIndicators: any[] = [];
    othersBlocksIndicator?.forEach((data: any) => {
      if (data?.indicators?.length) {
        const dataa = data?.indicators?.reduce((accumulator: any, option: any) => {
          if (option?.name?.toLowerCase()?.includes(filterValue?.toLowerCase())) {
            return [
              ...accumulator,
              <UnorderedList
                key={option?.id}
                onClick={() =>
                  selectOption(
                    `<p class="formula-block">${data?.name}</p>.<p class="formula-indicator">${option?.name}</p>`,
                    `'${data?.name}.${option?.name}'`,
                    'IndicatorsInOtherBlock',
                  )
                }
                display={'flex'}
                justifyContent={'space-between'}
                my={2}
              >
                <ListItem>
                  <Text className='formula-block'>{data?.name}</Text>
                  <Text className='formula-indicator'>{option?.name}</Text>
                </ListItem>
                <Text>{option?.help || ''}</Text>
              </UnorderedList>,
            ];
          }
          return accumulator;
        }, []);
        otherBlockIndicators.push(dataa);
      }
    });
    return otherBlockIndicators || [];
  }, [filterValue]);

  const getBlocks = useMemo(() => {
    return formulaList?.blocks?.reduce((accumulator: any, option: any) => {
      if (option?.name?.toLowerCase()?.includes(filterValue?.toLowerCase())) {
        return [
          ...accumulator,
          <UnorderedList
            key={option?.id}
            onClick={() =>
              selectOption(
                `<p class="formula-block">${option?.name}</p>`,
                `${option?.name}`,
                'Blocks',
              )
            }
            display={'flex'}
            justifyContent={'space-between'}
            my={2}
          >
            <ListItem>
              <Text className='formula-block'>{option?.name}</Text>
            </ListItem>
            <Text>{option?.help || ''}</Text>
          </UnorderedList>,
        ];
      }
      return accumulator;
    }, []);
  }, [filterValue]);

  const getDimensions = useMemo(() => {
    const dimensionalArray: any[] = [];
    formulaList?.dimensions?.forEach((data: any) => {
      if (data?.properties?.length) {
        const dataa = data?.properties?.reduce((accumulator: any, option: any) => {
          if (option?.name?.toLowerCase()?.includes(filterValue?.toLowerCase())) {
            return [
              ...accumulator,
              <UnorderedList
                key={option?.id}
                onClick={() =>
                  selectOption(
                    `<p class="formula-dimension">${data?.name}</p>.<p class="formula-property">${option?.name}</p>`,
                    `'${data?.name}.${option?.name}'`,
                    'Dimensions',
                  )
                }
                display={'flex'}
                justifyContent={'space-between'}
                my={2}
              >
                <ListItem>
                  <Text className='formula-dimension'>{data?.name}</Text>
                  <Text className='formula-property'>{option?.name}</Text>
                </ListItem>
              </UnorderedList>,
            ];
          }
          return accumulator;
        }, []);
        dimensionalArray.push(dataa);
      }
    });
    return dimensionalArray || [];
  }, [filterValue]);

  const getFunctions = useMemo(() => {
    return formulaList?.functions?.reduce((accumulator: any, option: any, index: number) => {
      if (option?.toLowerCase()?.includes(filterValue?.toLowerCase())) {
        return [
          ...accumulator,
          <UnorderedList
            key={index}
            onClick={() => selectOption(option, 'Functions')}
            display={'flex'}
            justifyContent={'space-between'}
            my={2}
          >
            <ListItem>
              <Text className='formula-function'>{option}</Text>
            </ListItem>
          </UnorderedList>,
        ];
      }
      return accumulator;
    }, []);
  }, [filterValue]);

  const handleFieldChanges = () => {
    dispatch(
      UpdateIndicatorFormula({
        indicatorId: selectedIndicators?.id,
        data: {
          formula,
        },
      }),
    ).then((response: any) => {
      if (response?.error) {
        fetchIndicatorsData();
        setMessage({ type: 'error', text: response?.payload, errorStatus: true });
      } else {
        fetchIndicatorsData();
        setMessage({ type: 'success', text: 'Formula parsed successfully', errorStatus: false });
      }
      setIsOptionsVisible(false);
    });
  };

  const handleInputChange = (data: any) => {
    if (message.type === 'success') {
      setMessage({ type: '', text: '', errorStatus: false });
    } else if (message.type === 'error') {
      setMessage({ type: 'error', text: message.text, errorStatus: false });
    }
    const value = formulaReference?.current?.innerText;
    setfilterValue(value ? value[0] : '');
    const lastTypedIndicator = value?.match(/\b(\w+)$/g);
    setFormula(value);
    setfilterValue(lastTypedIndicator ? lastTypedIndicator[0] : '');
  };

  const handleFormulaChange = (event: any) => {
    if (message.type === 'success') {
      setMessage({ type: '', text: '', errorStatus: false });
    } else if (message.type === 'error') {
      setMessage({ type: 'error', text: message.text, errorStatus: false });
    }
    const value = event?.currentTarget?.value;
    setfilterValue(value ? value[0] : '');
    const lastTypedIndicator = value?.match(/\b(\w+)$/g);
    setFormula(value);
    setfilterValue(lastTypedIndicator ? lastTypedIndicator[0] : '');
  };

  return (
    <Flex alignItems={'center'} width={'100%'}>
      <FunctionIconComponent
        color='white'
        style={{ margin: '0 10px 0 15px', height: 30, width: 30 }}
      />
      <Box alignItems={'center'} position={'relative'} width={'400px'} onBlur={handleFormulaBlur}>
        <Box
          ref={formulaReference}
          width={'400px'}
          backgroundColor={'white'}
          color={'black'}
          borderRadius={'8px'}
          fontSize={'xs'}
          height={9}
          outline={
            message?.type === 'error'
              ? '2px red solid'
              : message?.type === 'success'
              ? '2px green solid'
              : 'none'
          }
          contentEditable='true'
          onInput={handleInputChange}
          onKeyDown={(event) => {
            if (event?.keyCode === 13) handleFieldChanges();
          }}
          dangerouslySetInnerHTML={{ __html: formulaUI }}
        />
        {isOptionsVisible && filterValue !== null && (
          <Flex
            width={'100%'}
            flexDirection={'column'}
            p={4}
            position={'absolute'}
            top={'45px'}
            zIndex={4}
            backgroundColor={'white'}
            borderRadius={'8px'}
            color={'#212121'}
            maxH={'400px'}
            overflowY={'auto'}
            className='formula-bar'
          >
            <Box padding={'.5rem 0'} borderBottom={'1px #EFEEFD solid'}>
              <Text fontSize={'14px'} fontWeight={'600'} mb={3}>
                Indicators in this blocks
              </Text>
              {getIndicatorsInCurrentBlock}
            </Box>
            <Box padding={'.5rem 0'} borderBottom={'1px #EFEEFD solid'}>
              <Text fontSize={'14px'} fontWeight={'600'} mb={3}>
                Indicators in other blocks
              </Text>
              {getIndicatorsInOthersBlock}
            </Box>
            <Box padding={'.5rem 0'} borderBottom={'1px #EFEEFD solid'}>
              <Text fontSize={'14px'} fontWeight={'600'} mb={3}>
                Blocks
              </Text>
              {getBlocks}
            </Box>
            <Box padding={'.5rem 0'} borderBottom={'1px #EFEEFD solid'}>
              <Text fontSize={'14px'} fontWeight={'600'} mb={3}>
                Dimensions
              </Text>
              {getDimensions}
            </Box>
            <Box padding={'.5rem 0'} borderBottom={'1px #EFEEFD solid'}>
              <Text fontSize={'14px'} fontWeight={'600'} mb={3}>
                Functions
              </Text>
              <Flex className='formula-function-wrapper' flexWrap={'wrap'}>
                {getFunctions}
              </Flex>
            </Box>
          </Flex>
        )}
      </Box>
      {(message?.type === 'error' || message?.type === 'success') && (
        <Box
          ml={4}
          maxW={'max-content'}
          color={message.type === 'success' ? '#4bb6b9' : 'red'}
          fontSize={'2xs'}
          position={'relative'}
        >
          {message?.type === 'error' && (
            <InfoOutlineIcon
              onMouseOver={() => setHover(true)}
              onMouseLeave={() => setHover(false)}
              height={6}
              width={6}
            />
          )}
          {message?.type === 'success' && (
            <CheckCircleIcon height={6} width={6} color={'#4bb6b9'} />
          )}
          {((message?.type === 'error' && message?.errorStatus) || hover) && (
            <Flex
              width={'200px'}
              maxWidth={'200px'}
              backgroundColor={'#ecd3d3'}
              color={'red'}
              position={'absolute'}
              bottom={'30px'}
              padding={'.2rem .5rem'}
              borderRadius={'2px'}
              left={'50%'}
              transform={'translateX(-50%)'}
            >
              {message.text}
            </Flex>
          )}
        </Box>
      )}
    </Flex>
  );
};

export default NewToolbarFormula;
